const VIMEO_SDK_SRC = 'https://player.vimeo.com/api/player.js';

let sdkPromise;

// Load the Vimeo Player SDK once, on demand, and resolve with the global Vimeo object.
const loadVimeoSdk = () => {
  if (window.Vimeo) return Promise.resolve(window.Vimeo);
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = VIMEO_SDK_SRC;
    script.async = true;
    script.onload = () => resolve(window.Vimeo);
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return sdkPromise;
};

const initVimeoInlineVideo = () => {
  const playerEls = document.querySelectorAll('[data-vimeo-player]');

  playerEls.forEach(playerEl => {
    if (playerEl.dataset.vimeoInitialized === 'true') return;

    const trigger = playerEl.querySelector('[data-vimeo-trigger]');
    const iframe = playerEl.querySelector('[data-vimeo-iframe]');
    if (!trigger || !iframe) return;

    playerEl.dataset.vimeoInitialized = 'true';

    trigger.addEventListener('click', async () => {
      // Hide the cover immediately so the click feels instant; the player is
      // already loaded behind it, so playback starts as soon as the SDK responds.
      trigger.classList.add('opacity-0', 'pointer-events-none');

      try {
        const Vimeo = await loadVimeoSdk();
        const player = new Vimeo.Player(iframe);
        await player.setMuted(false);
        await player.play();
        trigger.remove();
      } catch {
        // SDK failed or autoplay was blocked — restore the cover so the user can retry.
        trigger.classList.remove('opacity-0', 'pointer-events-none');
      }
    });
  });
};

export default initVimeoInlineVideo;
